import { action } from 'satcheljs';

export default action('onComposeAddinsInitialized', (hostItemIndex: string) => ({
    hostItemIndex: hostItemIndex,
}));
